import { Routes as Switch, Route, useMatch as useRouteMatch } from 'react-router-dom';
import Head from './head';
import { Body } from 'components/reportBody';
import BodyCompiler from 'components/reportBody/newReportCompiler';
function TerritorialUnits({ isMobile, resetCounter, defaultSkip, queryString }) {
  const path = '';
  return (
    <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
      <Switch>

        <Route exact path={path} element={
          <Head
            resetCounter={resetCounter}
            defaultSkip={defaultSkip}
            queryString={queryString}
          />}
        />

        <Route exact path={`${path}/body`} element={
          <BodyCompiler 
            mainTitle={"Unità territoriali"}
            defaultSkip={defaultSkip}
            queryString={queryString} 
          />} 
        />

        <Route path={`${path}/*`} exact={true} element={
          <Head
            resetCounter={resetCounter}
            defaultSkip={defaultSkip}
            queryString={queryString}
          />}
        />
        
      </Switch>
    </main>
  );
}

export default TerritorialUnits;
